import { CustomChip } from '../../../components/chip/Chip';
import { insertColumnAfter, removeColumnByField } from '../../../helpers/tools';
import { colorEstadosChip, colorEstadosCIChip } from './colorsEstados';

const columnDiasDemora = {
    flex: 0.0015,
    field: 'fechaFinDemora',
    headerName: 'Fecha Demora',
    type: 'date'
};

const columnFechaRealizacion = {
    flex: 0.0016,
    field: 'fechaRealizacion',
    headerName: 'Fecha Realización',
    type: 'date',
    time: true
};

export const columnsResumenIngreso = [
    {
        flex: 0.0009,
        field: 'idEvaluacion',
        headerName: 'Contrato'
    },
    {
        flex: 0.0009,
        field: 'tipoEvaluacion',
        headerName: 'Origen'
    },
    {
        flex: 0.0010,
        field: 'programa',
        headerName: 'Programa'
    },
    {
        flex: 0.0020,
        field: 'cliente',
        headerName: 'Cliente'
    },
    {
        flex: 0.0008,
        field: 'hC',
        headerName: 'HC'
    },
    {
        flex: 0.0025,
        field: 'paciente',
        headerName: 'Paciente'
    },
    {
        flex: 0.0013,
        field: 'estadoRI',
        headerName: 'Estado RI',
        renderCell: ({ row }) => {
            const color = colorEstadosChip[row?.estadoRI];
            return (row?.estadoRI
                ? <CustomChip label={row?.estadoRI} {...color} />
                : <div className='center'>-</div>)
        }
    },
    {
        flex: 0.0015,
        field: 'estadoCoordinador',
        headerName: 'Estado Coordinador',
        renderCell: ({ row }) => {
            const color = colorEstadosChip[row?.estadoCoordinador];
            return (row?.estadoCoordinador
                ? <CustomChip label={row?.estadoCoordinador} {...color} />
                : <div className='center'>-</div>)
        }
    },
    {
        flex: 0.0013,
        field: 'profesionalASignado',
        headerName: 'Profesional Asignado para RI'
    },
    {
        flex: 0.0013,
        field: 'fechaLimite',
        headerName: 'Fecha Limite',
        type: 'date',
        time: true
    }
];

const columnsWithoutFechaLimite = removeColumnByField(columnsResumenIngreso, 'fechaLimite');

export const columnsRIWithFechaRealizacion = insertColumnAfter(columnsResumenIngreso, columnFechaRealizacion, 'fechaLimite');

export const columnsRIWithColumnDemora = insertColumnAfter(columnsWithoutFechaLimite, columnDiasDemora, 'profesionalASignado');